import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { useHistory } from 'react-router-dom';

const SubscribePrompt = ({ hostId, hostName, message }) => {
  const history = useHistory();

  const handleGoToProfile = () => {
    history.push(`/app/User/${hostId}`);
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="body1" sx={{ marginBottom: 2 }}>
        {message || `This is a private stream. Subscribe to ${hostName} to join.`}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleGoToProfile}
        sx={{
          textTransform: 'none',
          borderRadius: '20px',
          padding: '8px 24px',
        }}
      >
        Go to {hostName}'s Profile
      </Button>
    </Box>
  );
};

export default SubscribePrompt;